var _circle, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00195,
    cy: 8.00195,
    r: 8.00195,
    fill: "#164848"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.78516,
    y: 2.78333,
    width: 10.4373,
    height: 10.4373,
    fill: "url(#pattern0_1268_1330)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1268_1330",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1268_1330",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1268_1330",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAArlJREFUeAHt3EFOwkAYhmES15p4ATUe1Ft4Ald6DoMmQkm8gCFSaGPcu8MMYUwVKH+Z+TrFvm5qZDrTPq8lBCuDAV8IIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCQUODz8/msyCf3i8XkKuFhsLQTcDEWefZU5NmymGXTsny5RiaRwK8YLghREpX4e2X4GH7LldJumK1Xho/ht0RpJ8o6xnD19OTxd21n47f5fHTRzpH1cBXTlVGN856NptPX8x5S6U+ZGHpj8wrEMFPpBxJDb2xegRhmKv1AYuiNzSsQw0ylH0gMvbF5BWKYqfQDiaE3Nq9ADDOVfiAx9MbmFYhhptIPJIbe2LwCMcxU+oHE0BubVyCGmUo/kBh6Y/MKxDBT6QcSQ29sXoEYZir9QGLojc0r9DrGcvlwUubZjUMwiwkHrmPY7pvKs6W7L7crxx7M4mIUs8nd6qaxDtyD1Psr4yeGvzksYRRi+CvDx/DbBFGIsStGgijE2BejxSi9juFeAXx8PJ7+/LeQh6/ZLvJs6NCCXz1smWAdo5+vpqoeXfit7MIxVE2Sf58SJOXayeHrDiAFTIo16ww691ibQG2u1TnoJgfUBlQbazQ5586PVYIp5+48bMgBKuAUc4ac49HtGxMw5lxHBxnzgGNAxpgj5jkd/VwhoCH7Hj2c8gQOgZ3Ps8smb80UCd5ZVprJ524cJR9/mT4h4b/9pU9eorJA8yjrT9WpedOSK6MCfMi3UaPwNHVIgs19okQhxiZsyE+CohAjhH73vgdFIcZu0BiPNIpCjBjk++cwRSHGfsiYI2qjECMmtX2urVGIYQdUjPwVhRgK4uZzuihlPr512+Z7swcCCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAALRBL4BN/R0guqDOTQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.ffe45967b2963fa2e8812f50464640dd.svg";
export { ForwardRef as ReactComponent };